import { createSelector } from 'reselect';
import { transformPlaces } from './transformer';

export const getResearchState = (state) => state.research || {};

export const getResearchError = (state) => state.research.error || '';

export const getAllProjects = (state) => state.research.allProjects || [];
export const getAllProjectsState = createSelector(
    getAllProjects,
    (allProjects) => {
        return allProjects.map((project) => {
            return { ...project, title: project.name };
        });
    },
);

export const getAllPlaces = (state) => state.research.allPlaces || [];
export const getAllPlacesState = createSelector(getAllPlaces, (allPlaces) => {
    return allPlaces.map((place) => {
        return { ...place, title: place.name };
    });
});

export const getAllZones = (state) => state.research.allZones || [];
export const getAllZonesState = createSelector(getAllZones, (allZones) => {
    return allZones.map((zone) => {
        return { ...zone, title: zone.name };
    });
});

export const getPlacesState = (state) => state.research.places || [];

export const getSelectedPlacesState = (state) =>
    state.research.selectedPlaces || [];

export const getSelectedResearchersState = (state) =>
    state.research.selectedResearchers || [];

export const getSelectedResearchers = createSelector(
    getSelectedResearchersState,
    (selectedResearchers) => selectedResearchers,
);

export const getPlaces = createSelector(getPlacesState, (places) =>
    transformPlaces(places),
);

export const getAllProjectsLoading = createSelector(
    (state) => state.research.getAllProjectsLoading,
    (loading) => loading,
);

export const getAllPlacesLoading = createSelector(
    (state) => state.research.getAllPlacesLoading,
    (loading) => loading,
);

export const getAllZonesLoading = createSelector(
    (state) => state.research.getAllZonesLoading,
    (loading) => loading,
);

export const getPlacesLoading = createSelector(
    (state) => state.research.loadingPlaces,
    (loading) => loading,
);

export const createProjectLoading = createSelector(
    (state) => state.research.createProjectLoading,
    (loading) => loading,
);

export const createProjectSuccess = createSelector(
    (state) => state.research.createProjectSuccess,
    (createProjectSuccess) => createProjectSuccess,
);

export const assignPlacesLoading = createSelector(
    (state) => state.research.assigningPlaces,
    (loading) => loading,
);

export const getPlaceDetail = createSelector(
    (state, props) => state.research.placeDetail[props.placeId],
    (placeDetail) => {
        return placeDetail;
    },
);

export const getPlaceDetailLoading = createSelector(
    getResearchState,
    (research) => research.loadingPlaceDetail,
);

export const getPlaceAssignees = createSelector(
    getPlaceDetail,
    (detail) => detail.assignees,
);

export const getLocationName = createSelector(
    getResearchState,
    (research) => research.locationName,
);

export const getSelectedProject = createSelector(
    getResearchState,
    (research) => research.selectedProject,
);

export const getSelectedZone = createSelector(
    getResearchState,
    (research) => research.selectedZone,
);

export const getStatus = createSelector(
    getResearchState,
    (research) => research.status,
);

export const getLimit = createSelector(
    getResearchState,
    (research) => research.limit,
);

export const getSkip = createSelector(
    getResearchState,
    (research) => research.skip,
);
export const getFilterBy = createSelector(
    getResearchState,
    (research) => research.filterBy,
);
export const getSortBy = createSelector(
    getResearchState,
    (research) => research.sortBy,
);

export const getResearchers = createSelector(getResearchState, (research) =>
    research.researchers
        .filter((researcher) => researcher.status !== 'SENT')
        .map((researcher) => {
            return { ...researcher, title: researcher.fullName };
        }),
);

export const activePlaceIdState = (state) =>
    state.research.activePlaceId || null;

export const getActivePlaceId = createSelector(
    activePlaceIdState,
    (placeId) => placeId,
);

export const getHasMorePlacesState = (state) => state.research.hasMorePlaces;

export const getHasMorePlaces = createSelector(
    getHasMorePlacesState,
    (hasMorePlaces) => hasMorePlaces,
);

export const getSearchedOnce = createSelector(
    getResearchState,
    (research) => research.searchedOnce,
);

export const getEditPlaceLoading = createSelector(
    getResearchState,
    (research) => research.editingPlace,
);

export const unassignPlaceLoading = createSelector(
    getResearchState,
    (research) => research.removingResearcher,
);

export const getDeletePlaceLoading = createSelector(
    getResearchState,
    (research) => research.deletingPlace,
);
